import {AgeAuthVo} from '../../common/shared/api/nicolas/vo/AgeAuthVo.interface';
import {AgeAuth} from '../generated/types';

export function createAgeAuth(ageAuthVo: AgeAuthVo): Omit<AgeAuth, 'status'> {
  return {
    age: ageAuthVo.age,
    authenticatedAt: ageAuthVo.authenticated_at,
    bypassAgeLimit: ageAuthVo.bypass_age_limit,
  };
}
